import { useState, useEffect, useRef } from 'react';

// Components
import { Flex, Text, CustomButton } from '@/components';

// Redux
import { useSelector, useDispatch } from 'react-redux';

const CommentInput = ({ x, y, visible, onSave, onCancel }) => {
  const [text, setText] = useState('');
  const { primaryColor } = useSelector(({ theme }) => theme);
  const containerRef = useRef(null);

  // Cuando se hace visible, resetea el textarea
  useEffect(() => {
    if (visible) setText('');
  }, [visible]);

  // Clic fuera de la caja = cancelar (mismo efecto que el botón "Cancelar")
  useEffect(() => {
    if (!visible) return;

    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onCancel();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [visible, onCancel]);

  if (!visible) return null;

  const HORIZONTAL_OFFSET = 20;

  return (
    <div
      ref={containerRef}
      style={{
        position: 'absolute',
        top: y,
        left: x + HORIZONTAL_OFFSET,
        background: 'white',
        border: '1px solid #ccc',
        padding: '8px',
        lineHeight: 'normal',
        zIndex: 1000
      }}
    >
      <textarea
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder="Escribe tu comentario…"
        style={{ width: 200, height: 80 }}
      />
      <div style={{ marginTop: 4, textAlign: 'right' }}>
      <Flex justify="flex-end" gap="8px" mt="4px">
        <CustomButton
            bg={primaryColor}
            action={onCancel}
            pd="0px 8px"
            w="fit-content"
        >
            <Text clave="Cancelar" />
        </CustomButton>
        <CustomButton
            bg={primaryColor}
            action={() => onSave(text)}
            pd="0px 8px"
            w="fit-content"
        >
            <Text clave="Guardar" />
        </CustomButton>
     </Flex>
      </div>
    </div>
  );
};

export default CommentInput;
